import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { faEnvelope, faLock, faLongArrowRight, faKey} from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { UtilityService } from 'src/app/_services/utility.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css', '../login/login.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  faEnvelope = faEnvelope;
  faLock = faLock;
  faKey = faKey;
  submitted = false;
  confirm: boolean | null = null;
  notMatched = false;
  validatePassword: boolean | null = null;
  validateToken: boolean | null = null;
  minLength = 8;


  showPassword: boolean = false;
  showTemporary: boolean = false;
  showConfirm: boolean = false;
  linkToken: string | null = null;

  resetPasswordForm = new FormGroup({
    token: new FormControl(this.linkToken, [Validators.required]),
    password: new FormControl(null, [Validators.required, Validators.minLength(this.minLength)]),
    confirmPassword: new FormControl(null, [Validators.required, Validators.minLength(this.minLength)])
  });


  constructor(private router: Router, private authService: AuthService,  private route: ActivatedRoute, private utilityService: UtilityService, private title: Title) {

    this.linkToken = this.route.snapshot.url[1].path;
    this.resetPasswordForm.controls.token.patchValue(this.linkToken)


  }
  ngOnInit(): void {
    this.utilityService.setTitle("Password dimenticata");
    this.title.setTitle("Password dimenticata | Sviluppo personale");
  }


  get email() {
    return this.resetPasswordForm.get('email');
  }

  get token() {
    return this.resetPasswordForm.get('token');
  }

  get password() {
    return this.resetPasswordForm.get('password');
  }

  get confirmPassword() {
    return this.resetPasswordForm.get('confirmPassword');
  }

  onSubmit() {
    this.submitted = true;
    this.notMatched = false;
    if(!this.resetPasswordForm.controls['password'].valid || !this.resetPasswordForm.controls['token'].valid) {
      this.confirm = false;
      this.validatePassword = false;
    }
    else if(this.password && this.confirmPassword && this.password.value == this.confirmPassword.value) {
      this.confirm = true;
      this.validatePassword = true;
    }
    else {
      if(this.password && this.confirmPassword && this.password.value != this.confirmPassword.value) this.notMatched = true;
      this.confirm = false;
      this.validatePassword = true;
    }
    if(this.confirm) {
      this.confirm = null;
      this.validateToken = null;
      this.authService.reset_password(this.token?.value, this.password?.value, this.confirmPassword?.value).subscribe({ next: res => {
        if(res.msg == "Password has been successfully changed") {
          this.confirm = true;
          this.validateToken = true; 
          setTimeout(() => this.router.navigate(['/login']),
           1500);
        }
      }, error: e => {
      this.confirm = false;
      this.validateToken = false;
    }
    });
  }
}

switchTemporary(): void {
  this.showTemporary = !this.showTemporary;
  this.showTemporary ? 'text' : 'password'
}

switchPassword(): void {
  this.showPassword = !this.showPassword;
  this.showPassword ? 'text' : 'password'
}

switchConfirm(): void {
  this.showConfirm = !this.showConfirm;
  this.showConfirm ? 'text' : 'password'
}
}
